import '../pages/Overview.css';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import api from '../pages/api.json'
import Select from 'react-select';
import Plot from 'react-plotly.js';
import Mask_Group from '../assets/Mask group.svg';
import Grey_indicator from '../assets/Grey Indicator.svg';
import { CustomMultiSelect } from './CustomMultiSelect';
import Layout from './Layout';
import { Link } from 'react-router-dom';

function Overview({ username, onSignOut }) {
    //dropdown
    const [flatData, setFlatData] = useState([]);
    const [selectedBU, setSelectedBU] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState([]);
    const [selectedSubCategory, setSelectedSubCategory] = useState([]);
    const dropdown = api.OverViewDropdown;
    // Fetch and flatten dropdown data on mount
    const getOverViewDropdown = async () => {
        try {
            const response = await fetch(dropdown); // or full URL if needed
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log(data)
            return data;
        } catch (error) {
            console.error('Error fetching OverViewDropdown:', error);
            return null;
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await getOverViewDropdown();
                console.log("Raw API Response:", res);

                // Step 1: If it's an array with a string, grab the first element
                let parsed;
                if (Array.isArray(res) && typeof res[0] === "string") {
                    parsed = JSON.parse(res[0]);
                } else if (typeof res === "string") {
                    parsed = JSON.parse(res);
                } else {
                    parsed = res;
                }
                console.log()
                console.log("Parsed Response:", parsed);

                // Step 2: Now safely access dropdown_list_data
                const data = parsed?.dropdown_list_data;
                if (!data) {
                    console.warn("No dropdown_list_data found");
                    return;
                }

                // Step 3: Flatten
                const arr = [];
                Object.entries(data).forEach(([bu, countries]) => {
                    Object.entries(countries).forEach(([country, categories]) => {
                        Object.entries(categories).forEach(([category, subCats]) => {
                            subCats.forEach((subCat) => {
                                arr.push({
                                    bu,
                                    country,
                                    category,
                                    subCategory: subCat,
                                });
                            });
                        });
                    });
                });

                console.log("Flattened Data:", arr);
                setFlatData(arr);
            } catch (error) {
                console.error("Failed to fetch dropdown data", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);


    // Filter data according to selections
    const filteredData = useMemo(() => {
        return flatData.filter(item =>
            (selectedBU.length === 0 || selectedBU.some(sel => sel.value === item.bu)) &&
            (selectedCountry.length === 0 || selectedCountry.some(sel => sel.value === item.country)) &&
            (selectedCategory.length === 0 || selectedCategory.some(sel => sel.value === item.category)) &&
            (selectedSubCategory.length === 0 || selectedSubCategory.some(sel => sel.value === item.subCategory))
        );
    }, [flatData, selectedBU, selectedCountry, selectedCategory, selectedSubCategory]);

    const addSelectAllOption = (options) => [{ value: '__all__', label: 'Select All' }, ...options];

    // const filteredData = useMemo(() => {
    //     return flatData.filter((item) => {
    //         return (
    //             (!selectedBU || item.bu === selectedBU.value) &&
    //             (!selectedCountry || item.country === selectedCountry.value) &&
    //             (!selectedCategory || item.category === selectedCategory.value) &&
    //             (!selectedSubCategory ||
    //                 item.subCategory === selectedSubCategory.value)
    //         );
    //     });
    // }, [flatData, selectedBU, selectedCountry, selectedCategory, selectedSubCategory]);

    // Generate dropdown options
    // BU options - from filteredData if any filter is set, otherwise from flatData
    // const buOptions = useMemo(() => {
    //     const set = new Set(
    //         (selectedCountry || selectedCategory || selectedSubCategory ? filteredData : flatData)
    //             .map((d) => d.bu)
    //     );
    //     return Array.from(set).map((bu) => ({ value: bu, label: bu }));
    // }, [flatData, filteredData, selectedCountry, selectedCategory, selectedSubCategory]);

    // const countryOptions = useMemo(() => {
    //     const set = new Set(
    //         (selectedBU || selectedCategory || selectedSubCategory ? filteredData : flatData)
    //             .map((d) => d.country)
    //     );
    //     return Array.from(set).map((c) => ({ value: c, label: c }));
    // }, [flatData, filteredData, selectedBU, selectedCategory, selectedSubCategory]);

    // const categoryOptions = useMemo(() => {
    //     const set = new Set(
    //         (selectedBU || selectedCountry || selectedSubCategory ? filteredData : flatData)
    //             .map((d) => d.category)
    //     );
    //     return Array.from(set).map((cat) => ({ value: cat, label: cat }));
    // }, [flatData, filteredData, selectedBU, selectedCountry, selectedSubCategory]);

    // const subCategoryOptions = useMemo(() => {
    //     const set = new Set(
    //         (selectedBU || selectedCountry || selectedCategory ? filteredData : flatData)
    //             .map((d) => d.subCategory)
    //     );
    //     return Array.from(set).map((sub) => ({ value: sub, label: sub }));
    // }, [flatData, filteredData, selectedBU, selectedCountry, selectedCategory]);
    const sortAlphaNumeric = (a, b) => {
        const regex = /(\d+)/; // capture numbers
        const aMatch = a.match(regex);
        const bMatch = b.match(regex);

        if (aMatch && bMatch) {
            // Both have numbers -> compare prefix, then number
            const prefixA = a.replace(regex, '');
            const prefixB = b.replace(regex, '');
            if (prefixA !== prefixB) return prefixA.localeCompare(prefixB);

            return parseInt(aMatch[0], 10) - parseInt(bMatch[0], 10);
        }

        // Fallback to normal string compare
        return a.localeCompare(b);
    };

    // const buOptions = useMemo(() => {
    //     const dataSource = (selectedCountry.length || selectedCategory.length || selectedSubCategory.length) ? filteredData : flatData;
    //     const uniqueBUs = Array.from(new Set(dataSource.map(d => d.bu)))
    //         .sort((a, b) => a.localeCompare(b)); // Sort alphabetically
    //     return addSelectAllOption(uniqueBUs.map(bu => ({ value: bu, label: bu })));
    // }, [flatData, filteredData, selectedCountry, selectedCategory, selectedSubCategory]);
    const buOptions = useMemo(() => {
        const dataSource = (selectedCountry.length || selectedCategory.length || selectedSubCategory.length) ? filteredData : flatData;
        const uniqueBUs = Array.from(new Set(dataSource.map(d => d.bu)));

        uniqueBUs.sort(sortAlphaNumeric); // <-- sorted here

        return addSelectAllOption(uniqueBUs.map(bu => ({ value: bu, label: bu })));
    }, [flatData, filteredData, selectedCountry, selectedCategory, selectedSubCategory]);

    const countryOptions = useMemo(() => {
        const dataSource = (selectedBU.length || selectedCategory.length || selectedSubCategory.length) ? filteredData : flatData;
        const uniqueCountries = Array.from(new Set(dataSource.map(d => d.country)))
            .sort((a, b) => a.localeCompare(b));
        return addSelectAllOption(uniqueCountries.map(c => ({ value: c, label: c })));
    }, [flatData, filteredData, selectedBU, selectedCategory, selectedSubCategory]);

    const categoryOptions = useMemo(() => {
        const dataSource = (selectedBU.length || selectedCountry.length || selectedSubCategory.length) ? filteredData : flatData;
        const uniqueCategories = Array.from(new Set(dataSource.map(d => d.category)))
            .sort((a, b) => a.localeCompare(b));
        return addSelectAllOption(uniqueCategories.map(cat => ({ value: cat, label: cat })));
    }, [flatData, filteredData, selectedBU, selectedCountry, selectedSubCategory]);

    const subCategoryOptions = useMemo(() => {
        const dataSource = (selectedBU.length || selectedCountry.length || selectedCategory.length) ? filteredData : flatData;
        const uniqueSubCats = Array.from(new Set(dataSource.map(d => d.subCategory)))
            .sort((a, b) => a.localeCompare(b));
        return addSelectAllOption(uniqueSubCats.map(sub => ({ value: sub, label: sub })));
    }, [flatData, filteredData, selectedBU, selectedCountry, selectedCategory]);

    // const buOptions = useMemo(() => {
    //     const dataSource = (selectedCountry.length || selectedCategory.length || selectedSubCategory.length) ? filteredData : flatData;
    //     const uniqueBUs = Array.from(new Set(dataSource.map(d => d.bu)));
    //     return addSelectAllOption(uniqueBUs.map(bu => ({ value: bu, label: bu })));
    // }, [flatData, filteredData, selectedCountry, selectedCategory, selectedSubCategory]);

    // const countryOptions = useMemo(() => {
    //     const dataSource = (selectedBU.length || selectedCategory.length || selectedSubCategory.length) ? filteredData : flatData;
    //     const uniqueCountries = Array.from(new Set(dataSource.map(d => d.country)));
    //     return addSelectAllOption(uniqueCountries.map(c => ({ value: c, label: c })));
    // }, [flatData, filteredData, selectedBU, selectedCategory, selectedSubCategory]);

    // const categoryOptions = useMemo(() => {
    //     const dataSource = (selectedBU.length || selectedCountry.length || selectedSubCategory.length) ? filteredData : flatData;
    //     const uniqueCategories = Array.from(new Set(dataSource.map(d => d.category)));
    //     return addSelectAllOption(uniqueCategories.map(cat => ({ value: cat, label: cat })));
    // }, [flatData, filteredData, selectedBU, selectedCountry, selectedSubCategory]);

    // const subCategoryOptions = useMemo(() => {
    //     const dataSource = (selectedBU.length || selectedCountry.length || selectedCategory.length) ? filteredData : flatData;
    //     const uniqueSubCats = Array.from(new Set(dataSource.map(d => d.subCategory)));
    //     return addSelectAllOption(uniqueSubCats.map(sub => ({ value: sub, label: sub })));
    // }, [flatData, filteredData, selectedBU, selectedCountry, selectedCategory]);


    const customStyles = {
        control: (base, state) => ({
            ...base,
            border: '1px solid #ccc',
            borderRadius: '4px',
            paddingLeft: '10px',
            boxShadow: 'none',
            '&:hover': {
                borderColor: '#888'
            },
            backgroundColor: state.isDisabled ? '#f2f2f2' : 'white',
        }),
        menu: (base) => ({
            ...base,
            width: '100%', // make dropdown menu take full width
            zIndex: 9999,
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused
                ? '#F4F3FF' // custom hover color
                : state.isSelected
                    ? '#e6dcff' // selected option background
                    : 'white',
            color: 'black',
            cursor: 'pointer',
            '&:active': {
                backgroundColor: '#e6dcff',
            },
        }),
        singleValue: (base) => ({
            ...base,
            color: 'black',
        }),
        dropdownIndicator: (base) => ({
            ...base,
            color: '#666',
            '&:hover': {
                color: '#333',
            },
        }),
    };
    //submit
    const [response, setResponse] = useState('')
    const submitApi = api.OverViewSubmit;

    const debounceTimer = useRef(null);

    const fetchDataWithFilters = async () => {
        try {
            const queryParams = new URLSearchParams();

            const appendValues = (paramName, values) => {
                (Array.isArray(values) ? values : [values]).forEach(val => {
                    if (val && val.value) {
                        queryParams.append(paramName, val.value);
                    }
                });
            };

            appendValues('business_unit', selectedBU);
            appendValues('country', selectedCountry);
            appendValues('category', selectedCategory);
            appendValues('subcategory', selectedSubCategory);

            console.log("Query Params:", queryParams.toString());

            // First API call
            const response1 = await fetch(`${submitApi}?${queryParams.toString()}`);
            if (!response1.ok) throw new Error('First API call failed');
            const data1 = await response1.json();
            setResponse(data1);

            // Second API call
            const response2 = await fetch(`${graphApi}?${queryParams.toString()}`);
            if (!response2.ok) throw new Error('Second API call failed');
            const data2 = await response2.json();
            setGraphData(data2);

        } catch (error) {
            console.error("Error fetching data:", error);
            setResponse(error);
        } finally {
        }
    };

    // Trigger API calls when filters change
    useEffect(() => {
        if (debounceTimer.current) clearTimeout(debounceTimer.current);

        debounceTimer.current = setTimeout(() => {
            fetchDataWithFilters();
        }, 400); // 400ms debounce delay

        return () => clearTimeout(debounceTimer.current);
    }, [selectedBU, selectedCountry, selectedCategory, selectedSubCategory]);


    //graph 
    const graphApi = api.OverViewGraph;
    const [graphData, setGraphData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        const fetchGraphData = async () => {
            try {
                setLoading(true);
                const response = await fetch(graphApi);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();
                console.log("graphData", data)
                setGraphData(data);
            } catch (err) {
                setError('Failed to load graph data.');
                console.error('Fetch error:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchGraphData();
    }, [graphApi]);

    function breakTitle(title, maxLength = 30) {
        const words = title.split(" ");
        let line = "";
        const lines = [];

        words.forEach(word => {
            if ((line + word).length > maxLength) {
                lines.push(line.trim());
                line = "";
            }
            line += word + " ";
        });

        if (line.trim()) {
            lines.push(line.trim());
        }

        return lines.join("<br>");
    }
    function breakYAxisLabels(labels, maxWordsPerLine = 1) {
        return labels.map(label => {
            const words = label.split(" ");
            return words.reduce((acc, word, i) => {
                if (i % maxWordsPerLine === 0 && i !== 0) {
                    acc += "<br>";
                } else if (i !== 0) {
                    acc += " ";
                }
                return acc + word;
            }, "");
        });
    }


    const [hoverIdx, setHoverIdx] = React.useState(null);
    const renderBarChart = (title, dataset, index, totalCharts) => {


        // Step 1: Combine all data into a single array of objects for sorting
        const combinedData = dataset.x.map((label, i) => ({
            label,
            asIsSpend: dataset['As-is Spend'][i],
            savingsPotential: dataset['Savings Potential'][i],
        }));

        // Step 2: Sort by As-is Spend (low to high in your original, change if needed)
        combinedData.sort((a, b) => a.asIsSpend - b.asIsSpend);

        // Step 3: Extract sorted arrays
        const sortedLabels = combinedData.map(item => item.label);
        const sortedAsIsSpend = combinedData.map(item => item.asIsSpend);
        const sortedSavingsPotential = combinedData.map(item => item.savingsPotential);

        // Step 4: Break Y-axis labels and add spacing
        const yLabelsBroken = breakYAxisLabels(sortedLabels, 1);
        const axisLabelsWithSpacing = yLabelsBroken.map(label =>
            label.split('<br>').map(word => word + '\u00A0').join('<br>')
        );

        const yIndices = sortedLabels.map((_, i) => i);
        const barThickness = 40;
        const height = yIndices.length * barThickness + 100;

        // Create line/border styling arrays
        const lineWidths = new Array(yIndices.length).fill(0);
        const lineColors = new Array(yIndices.length).fill('transparent');

        let barColorsAsIs = new Array(yIndices.length).fill('#9F50D1');
        let barColorsSavings = new Array(yIndices.length).fill('#082D73');

        if (hoverIdx !== null) {
            barColorsAsIs = barColorsAsIs.map((c, i) =>
                i === hoverIdx ? '#D8A9F0' : '#9F50D1' // lighter purple
            );
            barColorsSavings = barColorsSavings.map((c, i) =>
                i === hoverIdx ? '#5C7DD1' : '#082D73' // lighter blue
            );
        }

        const formatNumber = (num) => {
            const n = Number(num); // ensure it's a number
            if (isNaN(n)) return num; // fallback if it's not numeric
            if (Math.abs(n) >= 1_000_000) {
                return (n / 1_000_000).toFixed(2) + 'M';
            } else if (Math.abs(n) >= 1_000) {
                return (n / 1_000).toFixed(2) + 'K';
            } else {
                return n.toFixed(2);
            }
        };

        return (
            <div key={title}>
                <Plot
                    data={[
                        {
                            type: 'bar',
                            y: yIndices,
                            x: sortedAsIsSpend,
                            name: 'As-is Spend',
                            orientation: 'h',
                            marker: {
                                color: barColorsAsIs,
                                line: {
                                    width: lineWidths,
                                    color: lineColors
                                }
                            },
                            text: sortedAsIsSpend.map(v => `$${formatNumber(v)}`),
                            textposition: 'inside',
                            insidetextanchor: 'start',
                            textfont: { color: 'white', size: 12 },
                            hoverinfo: 'none',
                            hovertemplate:
                                'As-is Spend<br>' +
                                '<b>%{y}</b>: <b>%{x:$,.2f}</b><extra></extra>',
                        },
                        {
                            type: 'bar',
                            y: yIndices,
                            x: sortedSavingsPotential,
                            name: 'Savings Potential',
                            orientation: 'h',
                            marker: {
                                color: barColorsSavings,
                                line: {
                                    width: lineWidths,
                                    color: lineColors
                                }
                            },
                            text: sortedSavingsPotential.map(v => `$${formatNumber(v)}`),
                            textposition: 'inside',
                            insidetextanchor: 'start',
                            textfont: { color: 'white', size: 12 },
                            hoverinfo: 'none',
                            hovertemplate:
                                'Savings Potential<br>' +
                                '<b>%{y}</b>: <b>%{x:$,.2f}</b><extra></extra>',
                        },
                    ]}
                    layout={{
                        barmode: 'stack',
                        showlegend: false,
                        hoverlabel: { align: 'left' },
                        yaxis: {
                            tickfont: { size: 12 },
                            tickmode: 'array',
                            tickvals: yIndices,
                            ticktext: axisLabelsWithSpacing,
                            showgrid: false,
                            ticklabelposition: 'outside',
                            tickpadding: 30,
                        },
                        xaxis: {
                            tickfont: { size: 12 },
                            showgrid: false,
                            side: 'top',
                        },
                        autosize: true,
                        height: height,
                        margin: { l: 100, r: 30, t: 40, b: 20 },
                        legend: { orientation: 'h' },
                        transition: {
                            duration: 500,
                            easing: 'cubic-in-out',
                        },
                        frame: {
                            duration: 500,
                            redraw: false,
                        }
                    }}
                    config={{
                        displaylogo: false,
                        responsive: true,
                        modeBarButtonsToRemove: [
                            'zoom2d', 'pan2d', 'select2d', 'lasso2d',
                            'zoomIn2d', 'zoomOut2d', 'autoScale2d',
                            'resetScale2d', 'hoverClosestCartesian',
                            'hoverCompareCartesian', 'toggleSpikelines',
                        ],
                    }}
                    style={{ width: '100%' }}
                    onHover={(e) => setHoverIdx(e.points[0].pointIndex)}
                    onUnhover={() => setHoverIdx(null)}
                />
            </div>
        );
    };

    return (
        <Layout username={username} onSignOut={onSignOut}>
            <div className="container-fluid">
                <div className='row'>
                    <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
                        <Link to="/">
                            <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                                    <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
                                </svg>
                                <span className="SummaryText">Home</span>
                            </span>
                        </Link>
                        <span>/</span>
                        <span className="HomeText">Overview Dashboard</span>
                    </div>
                </div>
            </div>
            <div className="w-full h-screen">
                <iframe
                    title="ShouldCost_Summary"
                    width="100%"
                    height="100%"
                    src="https://app.powerbi.com/reportEmbed?reportId=783aace5-e5a1-4e4b-ae9c-8911338590cb&autoAuth=true&ctid=e0793d39-0939-496d-b129-198edd916feb&navContentPaneEnabled=false"
                    frameBorder="0"
                    allowFullScreen
                    style={{ zoom: "1", transform: "scale(1)", transformOrigin: "0 0" }}
                ></iframe>
            </div>

        </Layout>
        // <Layout username={username} onSignOut={onSignOut}>
        //     <div className="container-fluid">
        //         <div className='row'>
        //             <div className="SummaryBreadCrumb border-b-[1px] border-[#CFCFCF] gap-2">
        //                 <Link to="/">
        //                     <span className="SummaryBreadCrumbInside cursor-pointer hover:text-black">
        //                         <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
        //                             <path d="M8.33464 17.4538V12.4538H11.668V17.4538H15.8346V10.7871H18.3346L10.0013 3.28711L1.66797 10.7871H4.16797V17.4538H8.33464Z" />
        //                         </svg>
        //                         <span className="SummaryText">Home</span>
        //                     </span>
        //                 </Link>
        //                 <span>/</span>
        //                 {/* <Link to="/LandingPage">
        //                     <span className="SummaryBreadCrumbInside hover:text-black cursor-pointer" >Should Cost Calculator</span>
        //                 </Link> */}
        //                 {/* <span>/</span> */}
        //                 <span className="HomeText">Overview Dashboard</span>
        //             </div>
        //         </div>

        //         <div className='row sticky top-0 z-[9999] bg-white pb-3'>
        //             <div className='col-1'></div>
        //             <div className='col-10 pt-4'>
        //                 <div className='w-full'>
        //                     <div className='overview-dropdown'>

        //                         <div className='overview-dropdownHeading'>
        //                             <div className='overview-dropdownText'>
        //                                 <span className='overview-text'>Business Unit</span>
        //                             </div>
        //                             <CustomMultiSelect
        //                                 placeholder="Select BU"
        //                                 options={buOptions}
        //                                 value={selectedBU}
        //                                 onChange={setSelectedBU}
        //                             />
        //                         </div>
        //                         <div className='overview-dropdownHeading'>
        //                             <div className='overview-dropdownText'>
        //                                 <span className='overview-text'>Country</span>
        //                             </div>
        //                             <CustomMultiSelect
        //                                 placeholder="Select Country"
        //                                 options={countryOptions}
        //                                 value={selectedCountry}
        //                                 onChange={setSelectedCountry}
        //                             />
        //                         </div>

        //                         <div className='overview-dropdownHeading'>
        //                             <div className='overview-dropdownText'>
        //                                 <span className='overview-text'>Category</span>
        //                             </div>
        //                             <CustomMultiSelect
        //                                 placeholder="Select Category"
        //                                 options={categoryOptions}
        //                                 value={selectedCategory}
        //                                 onChange={setSelectedCategory}
        //                             />
        //                         </div>

        //                         <div className='overview-dropdownHeading'>
        //                             <div className='overview-dropdownText'>
        //                                 <span className='overview-text'>Sub-Category</span>
        //                             </div>
        //                             <CustomMultiSelect
        //                                 placeholder="Select Sub-Category"
        //                                 options={subCategoryOptions}
        //                                 value={selectedSubCategory}
        //                                 onChange={setSelectedSubCategory}
        //                             />
        //                         </div>
        //                         {/* <div className='overview-dropdownHeading'>
        //                         <div className='overview-dropdownText'>
        //                             <span className='overview-text'>Business Unit</span>
        //                         </div>
        //                         <Select
        //                             className="overview-select"
        //                             classNamePrefix="react-select"
        //                             styles={customStyles}
        //                             placeholder="Select BU"
        //                             options={buOptions}
        //                             value={selectedBU}
        //                             onChange={setSelectedBU}
        //                             isClearable
        //                         />
        //                     </div>
        //                     <div className='overview-dropdownHeading'>
        //                         <div className='overview-dropdownText'>
        //                             <span className='overview-text'>Country</span>
        //                         </div>
        //                         <Select
        //                             className="overview-select"
        //                             classNamePrefix="react-select"
        //                             styles={customStyles}
        //                             placeholder="Select Country"
        //                             options={countryOptions}
        //                             value={selectedCountry}
        //                             onChange={setSelectedCountry}
        //                             isClearable
        //                         />
        //                     </div>
        //                     <div className='overview-dropdownHeading'>
        //                         <div className='overview-dropdownText'>
        //                             <span className='overview-text'>Category</span>
        //                         </div>
        //                         <Select
        //                             className="overview-select"
        //                             classNamePrefix="react-select"
        //                             styles={customStyles}
        //                             placeholder="Select Category"
        //                             options={categoryOptions}
        //                             value={selectedCategory}
        //                             onChange={setSelectedCategory}
        //                             isClearable
        //                         />
        //                     </div>
        //                     <div className='overview-dropdownHeading'>
        //                         <div className='overview-dropdownText'>
        //                             <span className='overview-text'>Sub-Category</span>
        //                         </div>
        //                         <Select
        //                             className="overview-select"
        //                             classNamePrefix="react-select"
        //                             styles={customStyles}
        //                             placeholder="Select Sub-Category"
        //                             options={subCategoryOptions}
        //                             value={selectedSubCategory}
        //                             onChange={setSelectedSubCategory}
        //                             isClearable
        //                         />
        //                     </div> */}
        //                     </div>
        //                 </div>
        //                 {/* </div> */}
        //                 {response?.filtered_data && (
        //                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mt-4">
        //                         {Object.entries(response.filtered_data).map(([label, value], idx) => {
        //                             const isPercentage = label.includes('%');
        //                             const displayValue = isPercentage
        //                                 ? `${value.toFixed(2)}%`
        //                                 : `$${(value / 1_000_000).toFixed(0)}M`;

        //                             const bgShades = ['white', 'white', 'white', 'white'];
        //                             const borderColors = [
        //                                 'border-[#7500C0]',
        //                                 'border-[#4285F4]',
        //                                 'border-[#FF50A0]',
        //                                 'border-[#05F2DB]',
        //                             ];

        //                             const cardBg = bgShades[idx % bgShades.length];
        //                             const borderColor = borderColors[idx % borderColors.length];

        //                             return (
        //                                 <div
        //                                     key={idx}
        //                                     className={`border-l-4 ${borderColor} ${cardBg} p-4 rounded-md shadow-[0_1px_4px_0_rgba(0,0,0,0.25)] flex flex-col justify-between`}
        //                                 >
        //                                     <div className="text-sm text-[#000000] font-normal">
        //                                         {label}
        //                                     </div>
        //                                     <div className="text-2xl font-semibold text-[#7500C0]">
        //                                         {displayValue}
        //                                     </div>
        //                                     {/* <div className="text-sm text-gray-600 font-medium">
        //                                         {label}
        //                                     </div> */}
        //                                 </div>
        //                             );
        //                         })}
        //                     </div>
        //                 )}
        //             </div>
        //             <div className='col-1'></div>
        //         </div>
        //         <div className="grid grid-cols-12 gap-4">
        //             <div className="col-span-1"></div>
        //             {loading ? (
        //                 <div className="col-span-10 flex justify-center items-center py-12">
        //                     <div>
        //                         <div className="chatbot-loaderInside text-center">
        //                             <span className="chatbot-loaderImg">
        //                                 <span className="relative inline-block w-8 h-8">
        //                                     <img
        //                                         src={Mask_Group}
        //                                         alt="Mask_Group"
        //                                         className="Mask_Group absolute top-0 left-0 w-full h-full animate-spin"
        //                                     />
        //                                     <img
        //                                         src={Grey_indicator}
        //                                         alt="Grey_indicator"
        //                                         className="Grey_indicator absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
        //                                     />
        //                                 </span>
        //                             </span>
        //                         </div>
        //                     </div>
        //                 </div>
        //             ) : error || !graphData ? (
        //                 <div className="col-span-10 text-red-500 text-center">{error || 'No graph data found.'}</div>
        //             ) : (
        //                 <div className="col-span-10 w-full bg-white">
        //                     {/* <h2 className="text-center text-2xl font-bold mb-8">
        //                         <span className="text-[#96939C]">Spend and Savings Overview</span>&nbsp;
        //                     </h2> */}

        //                     <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        //                         {Object.entries(graphData).map(([title, dataset], index) => (
        //                             <div key={title} className="bg-[#f4f3ff] rounded-xl p-3 h-[330px] flex flex-col"
        //                             >
        //                                 <div className="text-[#6b21a8] font-semibold text-center text-base mb-2 border-b pb-1">
        //                                     {title}
        //                                 </div>
        //                                 <div className="flex-grow overflow-auto overflow-x-hidden custom-scrollbar">
        //                                     {renderBarChart(title, dataset, index, Object.keys(graphData).length)}
        //                                 </div>
        //                             </div>
        //                         ))}
        //                     </div>
        //                 </div>
        //             )
        //             }
        //             <div className="col-span-1"></div>
        //         </div>
        //         {/* {loading ? (
        //             <div className="flex justify-center items-center py-12">
        //                 <div>
        //                     <div className="chatbot-loaderInside text-center">
        //                         <span className="chatbot-loaderImg">
        //                             <span className="relative inline-block w-8 h-8">
        //                                 <img
        //                                     src={Mask_Group}
        //                                     alt="Mask_Group"
        //                                     className="Mask_Group absolute top-0 left-0 w-full h-full animate-spin"
        //                                 />
        //                                 <img
        //                                     src={Grey_indicator}
        //                                     alt="Grey_indicator"
        //                                     className="Grey_indicator absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
        //                                 />
        //                             </span>
        //                         </span>
        //                     </div>
        //                 </div>
        //             </div>
        //         ) : error || !graphData ? (
        //             <div className="text-red-500 text-center">{error || 'No graph data found.'}</div>
        //         ) : (
        //             <div className="w-full px-4 bg-white">
        //                 <h2 className="text-center text-2xl font-bold mb-8">
        //                     <span className="text-[#96939C]">Spend and Savings Overview</span>&nbsp;
        //                 </h2>

        //                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        //                     {Object.entries(graphData).map(([title, dataset], index) => (
        //                         <div key={title} className="bg-[#f4f3ff] rounded-xl p-3 h-[330px] flex flex-col"
        //                         >
        //                             <div className="text-[#6b21a8] font-semibold text-center text-base mb-2 border-b pb-1">
        //                                 {title}
        //                             </div>
        //                             <div className="flex-grow overflow-auto overflow-x-hidden custom-scrollbar">
        //                                 {renderBarChart(title, dataset, index, Object.keys(graphData).length)}
        //                             </div>
        //                         </div>
        //                     ))}
        //                 </div>
        //             </div>
        //         )
        //         } */}
        //     </div >
        // </Layout>
    )
}
export default Overview;